import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-annular",
  "use": "icon-annular-usage",
  "viewBox": "0 0 198 198",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 198\" id=\"icon-annular\"><title>annular</title><path d=\"M99.05,198c-1.17,0-2.33,0-3.51-.06a99,99,0,1,1,3.51.06ZM99,7.65a91.35,91.35,0,0,0-3.15,182.64c1.08,0,2.16.06,3.23.06A91.35,91.35,0,0,0,102.19,7.71C101.11,7.67,100,7.65,99,7.65Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol